export const mastersPagination = {
    page: 1,
    limit: 200,
    sortBy: 'createdAt',
    sortOrder: 'desc',
};
